var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgCrossDelimiter = function (props) { return (_jsx("svg", __assign({ width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { stroke: "#fff", strokeWidth: 0.966, d: "m1.86 1.313 16.401 16.401M17.577 1.313l-16.4 16.401" }) }))); };
var Memo = memo(SvgCrossDelimiter);
export default Memo;
//# sourceMappingURL=CrossDelimiter.js.map